<template>
  <div>
    <div class="date-picker__input mb-2">
      <div class="date-picker__input--label my-1">Date</div>
      <v-date-input :value="date" @input="value => $emit('input', value)" />
    </div>
    <p class="text-grey-70 my-0">{{ heading }}</p>
  </div>
</template>

<script>
export default {
  components: {
    vDateInput: () => import("@/components/forms/vDateInput")
  },

  props: {
    date: { type: [String, Date], default: "" },
    heading: { type: String, default: "" }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.date-picker {
  &__input {
    &--label {
      font-weight: 600;
      margin: 12px 0;
    }
  }
}
</style>
